import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StoreService } from '../store/store.service';

export const isLoggedIn: CanActivateFn = () => {
  const store = inject(StoreService);
  const router = inject(Router);

  const { loggedIn } = store.getStore().getState().auth;

  if (!loggedIn) {
    router.navigate(['auth']);
  }
  return loggedIn;
};
